import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { InclusionType, UpsellInclusions } from '@shared/flight-itinerary/entities/upsell-flights';

@Component({
  selector: 'app-upsell-section',
  templateUrl: './upsell-section.component.html',
  styleUrls: ['./upsell-section.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UpsellSectionComponent {

  @Input() inclusions: UpsellInclusions[] = [];
  @Input() showBorder: boolean = true;

  constructor() { }

  get hasInclusions(): boolean {
    return this.inclusions?.length > 0;
  }

  get title(): string {
    const baseKey = 'FLIGHT_RESULTS_MODULE.UPSELL';
    switch (this.type) {
      case InclusionType.Included:
        return `${baseKey}.INCLUDED`;
      case InclusionType.NotOffered:
        return `${baseKey}.NOT_OFFERED`;
      case InclusionType.AtCharge:
        return `${baseKey}.AT_CHARGES`;
    }
  }

  get type(): string {
    return this.inclusions[0]?.Type;
  }

  public iconState(state: InclusionType): Icon {
    switch (state) {
      case InclusionType.Included:
        return Icon.Check;
      case InclusionType.AtCharge:
        return Icon.Monetization;
      default:
        return Icon.Close;
    }
  }

  public classState(state: InclusionType): IconFillColor {
    switch (state) {
      case InclusionType.Included:
        return IconFillColor.Success;
      case InclusionType.AtCharge:
        return IconFillColor.Warning;
      default:
        return IconFillColor.Error;
    }
  }

  public obtainSubtitle(inclusion: UpsellInclusions): string {
    return inclusion.Title || inclusion.SubTitle;
  }

  public rowNameEqualSubtitle(inclusion: UpsellInclusions): boolean {
    return inclusion.RowName !== inclusion.Title;
  }

}
